<template>
  <div class="hero container">
    <h1 class="hero-title">Donatrix</h1>
    <p class="hero-title__description">
      {{ $t('hero.TitleDescription') }}
    </p>
    <button class="hero-button btn" @click="openLogIn">
      {{ $t('hero.button') }}
    </button>
    <span class="hero-logo">
      <img src="images/heroLogo.gif" width="143px" height="103px" alt="logo" class="hero-logo__icon">
      <img src="images/Donatrix.png" class="donatrix" alt="donatrix">
      <span class="logo-descripton">New gamer - 1 ETH!</span>
    </span>
    <a href="#about" class="hero-scroll"></a>
    <span class="hero-bottom"></span>
  </div>
</template>
<script>
export default {
  props: {
    openLogIn: Function,
    rusLanguage: Function,
    engLanguage: Function,
  },
}
</script>
<style scoped lang="scss">
.hero {
  margin-top: 174px;
  text-align: center;
  position: relative;
}

.hero-title {
  margin-top: 0;
  margin-bottom: 13px;
  color: #FFF;
  text-align: center;
  font-family: Zen Dots;
  font-size: 70px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  /* 70px */
  text-transform: uppercase;
}

.hero-title__description {
  color: #FFF;
  text-align: center;
  font-family: Gilroy-Medium;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  /* 15px */
}

.hero-button {
  margin-top: 37px;
  margin-bottom: 101px;
  width: 225px;
  height: 47px;
}

.hero-logo {
  display: flex;
  position: absolute;
  width: 176px;
  height: 103px;
  left: 36.5%;
  top: 33%;
}

.hero-logo .donatrix {
  position: absolute;
  width: 77px;
  top: 54%;
  right: 2%;
}

.hero-logo .logo-descripton {
  position: absolute;
  bottom: 3px;
  right: 9px;
  color: #FF96FE;
  text-align: center;
  font-family: Space Mono;
  font-size: 9px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  /* 9px */
  text-transform: uppercase;
}

.hero-scroll {
  margin-top: 408px;
  width: 76.5px;
  height: 20px;
  display: flex;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-size: auto;
  background-image: url("data:image/svg+xml,%3Csvg width='78' height='22' viewBox='0 0 78 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.53553 2.46447L2.46447 2.53553C1.52678 3.47322 1 4.74499 1 6.07107V16.2974C1 17.6931 1.61991 19.0166 2.69206 19.91C3.53718 20.6143 4.60246 21 5.70256 21H35.1025C35.6961 21 36.2917 20.9042 36.8054 20.6067C37.3717 20.2788 38.0975 19.7446 38.5 19C38.9933 18.0874 39.2447 16.7331 39.372 15.6641C39.4998 14.5908 39.8768 13.5478 40.5688 12.7174C41.4757 11.6292 42.819 11 44.2356 11H45.1184C46.6251 11 48.0813 10.3361 48.8482 9.03921C49.2246 8.40256 49.5868 7.6838 49.7932 7C50.6191 4.26232 48.9092 2.46151 47.7477 1.59755C47.1518 1.15429 46.4078 1 45.6651 1H6.07107C4.74499 1 3.47321 1.52679 2.53553 2.46447Z' stroke='white' stroke-width='0.3'/%3E%3Cpath d='M71.3791 1H55.6213C54.2631 1 52.9604 1.53957 52 2.5C51.0396 3.46043 50.5 4.76306 50.5 6.12132V6.87868C50.5 8.23694 49.9604 9.53957 49 10.5C48.0396 11.4604 46.7369 12 45.3787 12H44.7026C43.6025 12 42.5372 12.3857 41.6921 13.09L41.4269 13.3109C40.5228 14.0644 40 15.1805 40 16.3574C40 17.4091 40.4178 18.4178 41.1615 19.1615L41.5 19.5C42.4604 20.4604 43.7631 21 45.1213 21H71.9996C73.2905 21 74.5387 20.5382 75.5188 19.6982C76.7705 18.6253 77.4644 17.0399 77.4034 15.3924L77.0736 6.48751C77.0259 5.20057 76.5438 3.96772 75.7057 2.98994C74.6231 1.72691 73.0426 1 71.3791 1Z' fill='%23FDC8FD'/%3E%3Cpath d='M62.2461 8L62.3508 14.598M62.3508 14.598L65.2728 11.5818M62.3508 14.598L59.5021 11.8384' stroke='black' stroke-width='0.5'/%3E%3Cpath d='M13.3002 10.048C13.3002 10.2293 13.3802 10.3733 13.5402 10.48C13.7002 10.5867 13.8949 10.6693 14.1242 10.728C14.3536 10.7867 14.5829 10.8533 14.8122 10.928C15.0416 10.9973 15.2362 11.1173 15.3962 11.288C15.5562 11.4533 15.6362 11.672 15.6362 11.944C15.6362 12.2853 15.5002 12.5627 15.2282 12.776C14.9616 12.9893 14.6149 13.096 14.1882 13.096C13.8042 13.096 13.4762 13.0107 13.2042 12.84C12.9376 12.6693 12.7509 12.448 12.6442 12.176L13.0922 11.912C13.1669 12.12 13.3002 12.2853 13.4922 12.408C13.6896 12.5253 13.9216 12.584 14.1882 12.584C14.4496 12.584 14.6682 12.5333 14.8442 12.432C15.0202 12.3253 15.1082 12.1627 15.1082 11.944C15.1082 11.7627 15.0282 11.6187 14.8682 11.512C14.7082 11.4053 14.5136 11.3227 14.2842 11.264C14.0549 11.2053 13.8256 11.1413 13.5962 11.072C13.3669 10.9973 13.1722 10.8773 13.0122 10.712C12.8522 10.5413 12.7722 10.32 12.7722 10.048C12.7722 9.72267 12.9002 9.45067 13.1562 9.232C13.4176 9.01333 13.7456 8.904 14.1402 8.904C14.4656 8.904 14.7509 8.97867 14.9962 9.128C15.2416 9.272 15.4229 9.46933 15.5402 9.72L15.1002 9.976C14.9456 9.60267 14.6256 9.416 14.1402 9.416C13.9109 9.416 13.7136 9.472 13.5482 9.584C13.3829 9.69067 13.3002 9.84533 13.3002 10.048ZM18.2638 13.096C17.6612 13.096 17.1598 12.896 16.7598 12.496C16.3598 12.0907 16.1598 11.592 16.1598 11C16.1598 10.408 16.3598 9.912 16.7598 9.512C17.1598 9.10667 17.6612 8.904 18.2638 8.904C18.6585 8.904 19.0132 9 19.3278 9.192C19.6425 9.37867 19.8718 9.632 20.0158 9.952L19.5838 10.2C19.4772 9.96 19.3038 9.77067 19.0638 9.632C18.8292 9.488 18.5625 9.416 18.2638 9.416C17.8212 9.416 17.4478 9.57067 17.1438 9.88C16.8398 10.184 16.6878 10.5573 16.6878 11C16.6878 11.4427 16.8398 11.8187 17.1438 12.128C17.4478 12.432 17.8212 12.584 18.2638 12.584C18.5625 12.584 18.8292 12.5147 19.0638 12.376C19.2985 12.232 19.4825 12.04 19.6158 11.8L20.0558 12.056C19.8905 12.376 19.6478 12.6293 19.3278 12.816C19.0078 13.0027 18.6532 13.096 18.2638 13.096ZM21.3419 9.664C21.5872 9.17867 22.0086 8.936 22.6059 8.936V9.448C22.2432 9.448 21.9419 9.55467 21.7019 9.768C21.4619 9.98133 21.3419 10.3173 21.3419 10.776V13H20.8139V9H21.3419V9.664ZM26.4393 12.496C26.034 12.896 25.538 13.096 24.9513 13.096C24.3647 13.096 23.866 12.896 23.4553 12.496C23.05 12.0907 22.8473 11.592 22.8473 11C22.8473 10.408 23.05 9.912 23.4553 9.512C23.866 9.10667 24.3647 8.904 24.9513 8.904C25.538 8.904 26.034 9.10667 26.4393 9.512C26.85 9.912 27.0553 10.408 27.0553 11C27.0553 11.592 26.85 12.0907 26.4393 12.496ZM23.8313 12.128C24.1353 12.432 24.5087 12.584 24.9513 12.584C25.394 12.584 25.7673 12.432 26.0713 12.128C26.3753 11.8187 26.5273 11.4427 26.5273 11C26.5273 10.5573 26.3753 10.184 26.0713 9.88C25.7673 9.57067 25.394 9.416 24.9513 9.416C24.5087 9.416 24.1353 9.57067 23.8313 9.88C23.5273 10.184 23.3753 10.5573 23.3753 11C23.3753 11.4427 23.5273 11.8187 23.8313 12.128ZM27.9389 13V7.16H28.4669V13H27.9389ZM29.5873 13V7.16H30.1153V13H29.5873Z' fill='white'/%3E%3C/svg%3E%0A");
}

.hero-bottom {
  display: block;
  padding-top: 118px;
}

@media (min-width: 1800px) {
  .hero {
    margin-top: 213px;
  }

  .hero-title {
    font-size: 90px;
  }

  .hero-title__description {
    font-size: 18px;
  }

  .hero-button {
    width: 288px;
    height: 56px;
    font-size: 18px;
  }

  .hero-logo {
    width: 213px;
    height: 137px;
    left: 35%;
  }

  .hero-logo__icon {
    width: 243px;
    height: 143px;
  }

  .hero-logo .donatrix {
    width: 103px;
    right: -21%;
  }

  .hero-logo .logo-descripton {
    bottom: 5px;
    right: -17px;
  }

  .hero-scroll {
    margin-top: 530px;
    width: 113px;
    height: 29.542px;
    background-size: cover;
  }

  .hero-bottom {
    padding-top: 144px;
  }
}

@media (min-width: 0px) and (max-width: 1290px) {
  .hero {
    margin-top: 61px;
  }

  .hero-title {
    font-size: 45px;
    margin-bottom: 9px;
  }

  .hero-title__description {
    font-size: 12px;
  }

  .hero-button {
    font-size: 12px;
    margin-top: 17px;
    margin-bottom: 0;
    min-width: 171px;
    width: -moz-max-content;
    width: max-content;
    height: 36px;
  }

  .hero-logo {
    width: 102px;
    height: 46px;
    left: 37.5%;
    top: 38.5%;
  }

  .hero-logo__icon {
    width: 84px;
    height: 50px;
  }

  .hero-logo .donatrix {
    width: 42px;
    right: 6%;
  }

  .hero-logo .logo-descripton {
    font-size: 5px;
    bottom: 4px;
    right: 0px;
  }

  .hero-scroll {
    margin-top: 285px;
  }

  .hero-bottom {
    padding-top: 35px;
  }
}

@media (max-width: 680px) {
  .hero {
    margin-top: 223px;
  }

  .hero-title {
    font-size: 40px;
    margin-bottom: 18px;
  }

  .hero-button {
    min-width: 225px;
    width: -moz-max-content;
    width: max-content;
    height: 47px;
    font-size: 15px;
    margin-top: 31px;
  }

  .hero-logo {
    display: none;
  }

  .hero-scroll {
    margin-top: 233px;
  }

  .hero-bottom {
    padding-top: 54px;
  }
}</style>